import listComponent from '@/util/proto/listComponent'
import './index.less'
const statusIcon = [
  { value: 0, label: 'success' },
  { value: 1, label: 'error' },
  { value: 2, label: 'warning' },
  { value: 3, label: 'default' },
  { value: 6, label: 'processing'},
]
export default {
  extends: listComponent,
  props:['companyId','value'],
  data(){
    return {
      data:[],
      loading:false,
      visible:false,
      stats:{
        bind:0 , 
        unbind:0,
        total:0
      },
      company:{},
    }
  },
  created(){
    this.$watch('companyId' , function(nv , ov){
      if(nv){
        this.search()
      }
    },{immediate:true , deep:false})
  },
  methods:{
    init(data){
      if( data === false ){
        this.visible = false
        this.company = {}
      }else{
        this.visible = true
        this.company = data
        this.search(data.id)
      }
    },
    search(id){
      this.data = []
      this.loading = true
     
      this.$request.screenCarInCompany(id || this.companyId).then( resp => {
        this.loading = false
        this.data = this.$utils.conv( resp.data || [] , { 'multipleState:statusIcon':statusIcon , 'multipleState':'carMultipleState' })
        this.stats.total = resp.data.length
        this.stats.bind = resp.data.reduce((t,c) => t + (c.courierId ? 1 : 0),0)
        this.stats.unbind = this.stats.total - this.stats.bind
      })
    },
    reset(){
      this.data = []
    },
    handleFullCar(){
      this.$emit('full')
    },
    toggleData(){

    },
    handleClick(data){
      this.$emit('click' , data)
    },
    handleClose(){
      this.visible = false
    },
    handleShow(data){
      console.log('show',data)
      this.$emit('show', data.carNo)
    }
  },
  render(){
    const stats = this.stats
    const company = this.company || {}
    return (
      <div class={["screen-carlist" , this.visible ? 'screen-carlist--visible' : null]}>
        <div class="screen-carlist__close" on-click={this.handleClose}><Icon type="ios-close" /></div>

        <div class="screen-carlist__header">
          <Avatar style="margin-right:8px;flex:none;" src={company.icon} size="large" />
          <span>{company.name}</span>
        </div>
        
        <div class="screen-carlist__stats">
          <div class="screen-carlist__stats-item">
            车辆： { stats.total}
          </div>
          <div class="screen-carlist__stats-item">
            已绑车： {stats.bind}
          </div>
        </div>
        <div class="screen-carlist__body">
        <sl-spin loading={this.loading}>
          { 
            this.data.map(row => (
              <div class="screen-carlist__item" on-click={() => this.handleClick(row)} >
                <div class="screen-carlist__item-header">
                  <div on-click={() => this.handleShow(row)}>
                    <a>No.{row.carNo}</a>
                    <span style="margin-left:8px;">{row.courierName}</span>
                  </div>
                  <div>
                    <sl-badge style={{'marginRight':'12px'}} status={row.statusIcon} />
                    {row.multipleStateText}
                  </div>
                </div>
                <div class="screen-carlist__item-body">
                  <div class><span class="label">车架号：</span>{row.frameNo}</div>
                  <div class="flex">
                    <div><span class="label">车牌号：</span>{row.licenseNo}</div>
                    <div><span class="label">品牌：</span>{row.brand}</div>
                  </div>
                  <div class><span class="label">保单号：</span>{row.insuranceNo}</div>
                </div>
              </div>
            ))
          }
        </sl-spin>
        </div>
      </div>
    )
  }
}